const TaxRegime = {
  fatca: 1,
  crs: 2,
  carf: 4
};

export default TaxRegime;
